module.exports = __webpack_public_path__ + "static/media/credit-cardcredit-card.45d31b8c.svg";